module.exports = __webpack_public_path__ + "img/valentes.f89b5065.png";